import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, LeafIcon, SparkleIcon } from './Icons';
export function RevelationSection() {
  return <section className="relative w-full py-20 sm:py-28 overflow-hidden" style={{
    background: 'linear-gradient(180deg, #0a0f0a 0%, #111a11 30%, #162014 60%, #111a11 100%)'
  }} aria-label="The solution" data-id="element-313">
      {/* Subtle decorative line */}
      <div className="max-w-24 mx-auto mb-16 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" aria-hidden="true" data-id="element-314" />

      <div className="max-w-3xl mx-auto px-5 sm:px-8" data-id="element-315">
        {/* Opening question */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="mb-16" data-id="element-316">
          <p className="font-serif text-xl sm:text-2xl md:text-3xl text-cream leading-relaxed" data-id="element-317">
            What if I told you that adding just a few specific, cheap
            ingredients from your local grocery store could{' '}
            <span className="text-gold font-semibold" data-id="element-318">
              neutralize the inflammation
            </span>{' '}
            killing your dog?
          </p>
        </motion.div>

        {/* The "No" statements */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="space-y-5 mb-16" data-id="element-319">
          <div className="flex items-center gap-4" data-id="element-320">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-urgency-red/20 flex items-center justify-center" data-id="element-321">
              <XIcon className="w-4 h-4 text-urgency-red-bright" data-id="element-322" />
            </div>
            <p className="font-sans text-base sm:text-lg text-cream-muted" data-id="element-323">
              No $400/month subscription boxes.
            </p>
          </div>
          <div className="flex items-center gap-4" data-id="element-324">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-urgency-red/20 flex items-center justify-center" data-id="element-325">
              <XIcon className="w-4 h-4 text-urgency-red-bright" data-id="element-326" />
            </div>
            <p className="font-sans text-base sm:text-lg text-cream-muted" data-id="element-327">
              No complicated kitchen science.
            </p>
          </div>
        </motion.div>

        {/* The positive — Hybrid Bowl Method */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="relative py-10 px-6 sm:px-10 bg-bg-card/60 border border-green-deep/40 rounded-xl" data-id="element-328">
          <div className="flex items-start gap-4" data-id="element-329">
            <div className="flex-shrink-0 mt-1" data-id="element-330">
              <LeafIcon className="w-7 h-7 text-green-accent" data-id="element-331" />
            </div>
            <div data-id="element-332">
              <p className="font-sans text-lg sm:text-xl text-cream leading-relaxed" data-id="element-333">
                Just{' '}
                <span className="font-semibold text-cream" data-id="element-334">
                  15 minutes a week
                </span>{' '}
                and the
              </p>
              <p className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-gold mt-2 flex items-center gap-3" data-id="element-335">
                <SparkleIcon className="w-5 h-5 text-gold/60 flex-shrink-0" data-id="element-336" />
                Hybrid Bowl Method
                <SparkleIcon className="w-5 h-5 text-gold/60 flex-shrink-0" data-id="element-337" />
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}